/* Vinyasa Living — scroll effects for About / Contact / FAQ pages.
   Reveal on scroll, parallax, word-by-word scrub, sticky chapters, count-up.
   Respects prefers-reduced-motion. Works with the theme's .page-wrapper scroller. */
(() => {
  if (window.__vlScroll) return;
  window.__vlScroll = true;
  document.documentElement.classList.add('vl-js');

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const clamp = (v, a = 0, b = 1) => Math.min(b, Math.max(a, v));
  const scrubbers = new Set();

  function countUp(el) {
    const target = parseFloat(el.dataset.vlCount);
    const decimals = (el.dataset.vlCount.split('.')[1] || '').length;
    if (reduce || isNaN(target)) { el.textContent = el.dataset.vlCount; return; }
    const start = performance.now();
    const dur = 1600;
    const step = (t) => {
      const p = clamp((t - start) / dur);
      const eased = 1 - Math.pow(1 - p, 3);
      el.textContent = (target * eased).toLocaleString('en-IN', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }

  function init(root) {
    root = root || document;

    // Reveal
    const reveals = root.querySelectorAll('[data-vl-reveal]:not(.is-in)');
    const counters = root.querySelectorAll('[data-vl-count]');
    if (reduce || !('IntersectionObserver' in window)) {
      reveals.forEach((el) => el.classList.add('is-in'));
      counters.forEach((el) => (el.textContent = el.dataset.vlCount));
    } else {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-in');
          if (e.target.hasAttribute('data-vl-count')) countUp(e.target);
          io.unobserve(e.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
      reveals.forEach((el) => io.observe(el));
      counters.forEach((el) => io.observe(el));
    }

    // Sticky chapters: swap the pinned image as each chapter reaches mid-screen
    root.querySelectorAll('[data-vl-chapters]').forEach((wrap) => {
      const imgs = wrap.querySelectorAll('[data-vl-chapter-img]');
      const chapters = wrap.querySelectorAll('[data-vl-chapter]');
      const nums = wrap.querySelectorAll('[data-vl-chapter-dot]');
      const setActive = (i) => {
        imgs.forEach((im) => im.classList.toggle('is-active', im.dataset.vlChapterImg === i));
        chapters.forEach((c) => c.classList.toggle('is-active', c.dataset.vlChapter === i));
        nums.forEach((n) => n.classList.toggle('is-active', n.dataset.vlChapterDot === i));
      };
      if (!('IntersectionObserver' in window)) return;
      const cio = new IntersectionObserver((entries) => {
        entries.forEach((e) => { if (e.isIntersecting) setActive(e.target.dataset.vlChapter); });
      }, { rootMargin: '-45% 0px -45% 0px' });
      chapters.forEach((c) => cio.observe(c));
    });

    if (reduce) return;
    root.querySelectorAll('[data-vl-parallax], [data-vl-words]').forEach((el) => scrubbers.add(el));
    tick();
  }

  // Scroll-linked effects
  let raf = 0;
  function tick() {
    raf = 0;
    const vh = window.innerHeight;
    scrubbers.forEach((el) => {
      if (!el.isConnected) { scrubbers.delete(el); return; }
      const r = el.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) return;
      if (el.hasAttribute('data-vl-parallax')) {
        const speed = parseFloat(el.dataset.vlParallax) || 0.15;
        const centre = r.top + r.height / 2 - vh / 2;
        el.style.transform = `translate3d(0, ${(-centre * speed).toFixed(1)}px, 0) scale(1.12)`;
      }
      if (el.hasAttribute('data-vl-words')) {
        const words = el.querySelectorAll('.vl-w');
        const p = clamp((vh * 0.85 - r.top) / (r.height + vh * 0.35));
        const lit = p * words.length;
        words.forEach((w, i) => { w.style.opacity = (0.18 + 0.82 * clamp(lit - i)).toFixed(3); });
      }
    });
  }
  const onScroll = () => { if (!raf) raf = requestAnimationFrame(tick); };
  document.addEventListener('scroll', onScroll, { passive: true, capture: true });
  window.addEventListener('resize', onScroll, { passive: true });

  const boot = () => init(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
